import Vue from 'vue';
import { MutationTree } from 'vuex';
import { UserInfo, UserState } from './state';

const mutations: MutationTree<UserState> = {
  SET_USER(state, user: UserInfo) {
    state.user = { ...state.user, ...user };
  },
};

export default mutations;
